/** Memorial checkout price for Meta Pixel custom data (EUR). Override at build time. */
const raw = import.meta.env.VITE_META_CHECKOUT_VALUE;
const parsed = raw != null && raw !== '' ? Number(raw) : 15;

export const META_CHECKOUT_VALUE = Number.isFinite(parsed) && parsed > 0 ? parsed : 15;
export const META_CHECKOUT_CURRENCY = 'EUR';
